import { render, staticRenderFns } from "./ChannelList.vue?vue&type=template&id=598ba94b&scoped=true&"
import script from "./ChannelList.vue?vue&type=script&lang=js&"
export * from "./ChannelList.vue?vue&type=script&lang=js&"
import style0 from "./ChannelList.vue?vue&type=style&index=0&id=598ba94b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598ba94b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('598ba94b')) {
      api.createRecord('598ba94b', component.options)
    } else {
      api.reload('598ba94b', component.options)
    }
    module.hot.accept("./ChannelList.vue?vue&type=template&id=598ba94b&scoped=true&", function () {
      api.rerender('598ba94b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/ChannelList.vue"
export default component.exports